import { render, staticRenderFns } from "./Sobre.vue?vue&type=template&id=013883ef"
import script from "./Sobre.vue?vue&type=script&lang=ts"
export * from "./Sobre.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('013883ef')) {
      api.createRecord('013883ef', component.options)
    } else {
      api.reload('013883ef', component.options)
    }
    module.hot.accept("./Sobre.vue?vue&type=template&id=013883ef", function () {
      api.rerender('013883ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Sobre.vue"
export default component.exports